<template>
  <div class="fulfillment-question-main">
    <div>
      <h1 class="fulfillment-title-step-2">Preguntas de Seguridad</h1>
      <h1 class="fulfillment-title">{{ question.text }}</h1>

      <Timer
        ref="time"
        :max="questionDuration"
        :stopped="sending"
        :key="`timer-${question.questionId}`"
        @finish="$emit('leavequestionauth', { reason: 'timeout' })"
      ></Timer>

      <ul class="fulfillment-alternative-container" v-bind:class="{ disabled: sending }">
        <li
          class="fulfillment-alternative"
          v-bind:style="{ borderColor: color }"
          @click="alternativeId = alternative.alternativeId"
          v-for="alternative in question.alternatives"
          :key="`alternative-${alternative.alternativeId}`"
        >
          <div
            v-bind:style="{ borderColor: color }"
            v-bind:class="{
              active: alternative.alternativeId === alternativeId
            }"
            class="fulfillment-check"
          >
            <i
              v-bind:style="{
                backgroundColor: alternative.alternativeId === alternativeId ? color : '#fff'
              }"
              class="fulfillment-circle-color"
            ></i>
          </div>
          {{ alternative.text }}
        </li>
      </ul>

      <div class="fulfillment-footer-section">
        <div class="fulfillment-col">
          <a
            class="fulfillment-link"
            @click="$emit('leavequestionauth', { reason: 'canceled' })"
            v-bind:style="{ color: '#aeaeae'}"
          >
            Cancelar
          </a>
        </div>
        <div class="fulfillment-col fulfillment-right">
          <button
            v-if="!sending"
            v-bind:style="{
              backgroundColor: alternativeId !== null ? color : '#e6e6e6'
            }"
            v-bind:class="{
              'fulfillment-disabled': alternativeId === null,
              'fulfillment-blue': alternativeId !== null
            }"
            class="fulfillment-button"
            @click="sendAnswer"
          >
            Continuar
          </button>
          <button v-else class="fulfillment-button fulfillment-disabled">
            <svg
              class="fulfillment-spinner"
              height="40"
              width="40"
              :style="{ strokeDasharray: '132px', strokeDashoffset: '80px' }"
            >
              <circle cx="20" cy="20" r="10" :stroke="color" stroke-width="4" fill="#e6e6e6" />
            </svg>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Timer from "./TimerComponent.vue";

export default {
  name: "Question",
  components: {
    Timer
  },
  data() {
    return {
      alternativeId: null,
      sending: false
    };
  },
  props: {
    question: { type: Object, required: true },
    durationInMillis: { type: Number, required: true },
    transactionId: { type: String, required: true },
    color: { type: String, default: "#0091DA" }
  },
  methods: {
    sendAnswer() {
      this.$emit("next", {
        questionId: this.question.questionId,
        alternativeId: this.alternativeId,
        durationInMillis: this.$refs.time.accumulatedTime
      });
      this.sending = true;
    }
  },
  computed: {
    questionDuration() {
      return this.durationInMillis / 1000;
    }
  }
};
</script>

<style scoped>
.fulfillment-question-main {
  color: #4a4a4a;
  padding: 15px;
  max-width: 600px;
  margin: auto;
}

.fulfillment-title {
  font-weight: 500;
  font-size: 18px;
  text-align: center;
  margin-top: 0px;
}

.fulfillment-title-step-2 {
  color: #0076cf;
  font-family: "FS Elliot Pro", sans-serif;
  font-size: 24px;
  letter-spacing: 0;
  line-height: 35px;
  text-align: left;
}

.fulfillment-paragraph {
  font-size: 18px;
}
.fulfillment-v-middle {
  vertical-align: middle;
}
.fulfillment-mb-20 {
  margin-bottom: 20px;
}
.fulfillment-pl-15 {
  padding-left: 15px;
}
.fulfillment-pr-15 {
  padding-right: 15px;
}
.fulfillment-w-100 {
  width: 100%;
}

.fulfillment-alternative {
  border: 1px solid #0091da;
  border-radius: 6px;
  padding: 8px;
  box-sizing: border-box;
  margin-bottom: 15px;
  cursor: pointer;
  transition: all 0.4s;
}

.fulfillment-alternative:hover {
  box-shadow: 0 5px 12px 0 rgba(0, 0, 0, 0.17);
}

.fulfillment-check {
  border: 1px solid;
  display: inline-block;
  border-radius: 100%;
  vertical-align: bottom;
  position: relative;
  margin-right: 10px;
}

.fulfillment-check.active .fulfillment-circle-color {
  border-color: white;
}

.fulfillment-circle-color {
  width: 18px;
  height: 18px;
  border-radius: 100%;
  background-color: white;
  display: block;
  border: 1px solid transparent;
  box-sizing: border-box;
}

.fulfillment-spinner {
  animation-duration: 1s;
  animation-name: spinner;
  animation-iteration-count: infinite;
}

@keyframes spinner {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

.fulfillment-alternative-container {
  list-style: none;
  padding: 0px;
}

.fulfillment-disabled {
  cursor: default;
  outline: none;
  pointer-events: none;
}

.fulfillment-footer-section {
  display: table;
  width: 100%;
  margin-top: 27px;
}

.fulfillment-col {
  display: table-cell;
  vertical-align: middle;
}
.fulfillment-form {
  max-width: 345px;
  font-weight: bold;
}
.fulfillment-right {
  text-align: right;
}
.fulfillment-center {
  text-align: center;
}
.fulfillment-href {
  text-decoration: underline;
  cursor: pointer;
}
button {
  outline: none;
  font-family: "FS Elliot Pro", Helvetica, Arial, sans-serif;
}

.fulfillment-button {
  min-height: 44px;
  min-width: 149px;
  border-radius: 22px;
  background-color: #e6e6e6;
  border: none;
  font-weight: bold;
  color: #757575;
  font-size: 16px;
  cursor: pointer;
}

.fulfillment-link {
  color: #0091da;
  font-weight: bold;
  text-decoration: none;
  font-size: 16px;
  cursor: pointer;
  padding-left: 15px;
}

.fulfillment-blue {
  background-color: #0091da;
  color: white;
  outline: none;
}
.fulfillment-blue-text {
  color: #0091da;
}

@media screen and (max-width: 674px) {
  .fulfillment-show-mobile {
    display: block;
  }
  .fulfillment-rut-pictures-container .fulfillment-col {
    display: block;
    text-align: center;
    padding: 0px 10px 10px;
    margin-bottom: 23px;
  }

  .fulfillment-rut-pictures-container img {
    max-width: 290px;
  }
}
</style>
